import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/auth-store'
import type { Json } from '@/types/supabase'

export interface SocialLinks {
  instagram?: string
  youtube?: string
  tiktok?: string
  facebook?: string
  spotify?: string
}

interface UpdateProfileInput {
  tagline?: string | null
  social_links?: SocialLinks
  logo_url?: string | null
  description?: string | null
  asset_id?: string | null
  banner_url?: string | null
  banner_asset_id?: string | null
  concept_photo_url?: string | null
  concept_asset_id?: string | null
  brand_color?: string | null
  province?: string | null
  city?: string | null
}

export function useUpdateTenantProfile() {
  const qc = useQueryClient()
  const tenantId = useAuthStore((s) => s.currentTenant?.id)

  return useMutation({
    mutationFn: async (input: UpdateProfileInput) => {
      const { data, error } = await supabase
        .from('tenants')
        .update({ ...input, social_links: input.social_links as unknown as Json | undefined })
        .eq('id', tenantId!)
        .select('id,tagline,social_links,logo_url,description,banner_url,banner_asset_id,concept_photo_url,concept_asset_id,brand_color,province,city')
        .single()

      if (error) throw error
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['tenant'] })
      qc.invalidateQueries({ queryKey: ['assets', tenantId] })
    },
  })
}
